import GeneralDisclosuresLink from '@/components/compliance/GeneralDisclosuresLink';
import { Link, Text } from '@chakra-ui/react';
import { PRIVACY_POLICY_LINK } from '@common/compliance';
import { FlexCol } from '../common/Flex';

export const IdvIntroDisclosure = () => {
    return (
        <FlexCol gap={3}>
            <Text fontSize="sm" color="gray.400">
                As an investment adviser, Plenty Financial has a legal
                requirement to verify your identity and to protect all personal
                information that you provide. Please see Plenty Financial’s{' '}
                <Link
                    href={PRIVACY_POLICY_LINK}
                    isExternal
                    textDecoration="underline"
                >
                    privacy policy
                </Link>{' '}
                and general disclosures, as well as our partner{' '}
                <Link
                    href="https://legal.atomicvest.com/usa.privacy.de3d0277-78f7-4741-9e9f-755f6b4f03ba.pdf"
                    isExternal
                    textDecoration="underline"
                >
                    Atomic’s Privacy Policy.
                </Link>{' '}
                Plenty RIA has a relationship with Atomic Invest LLC, an
                SEC-registered investment advisor, that serves as a sub-advisor
                to Plenty RIA. Neither Atomic Invest nor Atomic Brokerage, LLC (
                <Link
                    href="https://www.finra.org/"
                    isExternal
                    textDecoration="underline"
                >
                    FINRA
                </Link>{' '}
                registered broker-dealer and member of{' '}
                <Link
                    href="https://www.sipc.org/"
                    isExternal
                    textDecoration="underline"
                >
                    SIPC
                </Link>
                ), nor any of their affiliates is a bank. Investments held at
                Pershing are SIPC insured subject to certain limitations.
                Atomic&apos;s RIA has no SIPC insurance. Investments are not
                FDIC insured, are not bank guaranteed, and may lose value.
                Plenty RIA does not utilize Atomic Brokerage for its client
                accounts. Investing involves risk, including the loss of
                principal. There is no guarantee that the investment will
                provide positive performance over any period of time. Further,
                any investing strategy involves legal, regulatory,
                macroeconomic, liquidity and other risks which could negatively
                impact returns. Similarly, operational risk, such as business
                continuity risk could negatively affect investment results.
                Further, opportunity risk exists insofar as other investments
                may have similar or superior characteristics. Please see
                Plenty’s <GeneralDisclosuresLink />. Custodial, clearing,
                execution, and other brokerage services are provided to Atomic
                Invest by Pershing LLC, one of the world’s largest securities
                servicing companies.
            </Text>
        </FlexCol>
    );
};
